import React from 'react';
import ColorPicker from 'src/components/ColorPicker/ColorPicker';
import { Item as ItemWrapper } from 'src/components/Layouts';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const ResponsiveText = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { data, onChange, hideBkgColor } = props;
  const {
    backgroundColor,
    subtitleColor,
    contentPageNameColor,
    contentPageSummaryColor,
  } = data || {};

  return (
    <React.Fragment>
      {!hideBkgColor && (
        <ItemWrapper size='small' title={getI18n('general.backgroundColour')}>
          <ColorPicker
            color={backgroundColor}
            multi
            onChange={(backgroundColor) => {
              onChange({ backgroundColor });
            }}
          />
        </ItemWrapper>
      )}
      <ItemWrapper size='small' title={getI18n('general.subtitleColour')}>
        <ColorPicker
          color={subtitleColor}
          multi
          onChange={(subtitleColor) => {
            onChange({ subtitleColor });
          }}
        />
      </ItemWrapper>
      <ItemWrapper
        size='small'
        title={getI18n('general.contentPageNameColour')}>
        <ColorPicker
          color={contentPageNameColor}
          multi
          onChange={(contentPageNameColor) => {
            onChange({ contentPageNameColor });
          }}
        />
      </ItemWrapper>
      <ItemWrapper
        size='small'
        title={getI18n('general.contentPageSummaryColour')}>
        <ColorPicker
          color={contentPageSummaryColor}
          multi
          onChange={(contentPageSummaryColor) => {
            onChange({ contentPageSummaryColor });
          }}
        />
      </ItemWrapper>
      {/* <ItemWrapper size='small' title='Product Name Colour'>
        <ColorPicker
          color={productNameColor}
          multi
          onChange={(productNameColor) => {
            onChange({ productNameColor });
          }}
        />
      </ItemWrapper>{' '}
      <ItemWrapper size='small' title='Body Text Colour'>
        <ColorPicker
          color={bodyTextColor}
          multi
          onChange={(bodyTextColor) => {
            onChange({ bodyTextColor });
          }}
        />
      </ItemWrapper>{' '}
      <ItemWrapper size='small' title='List Price Colour'>
        <ColorPicker
          color={listPriceColor}
          multi
          onChange={(listPriceColor) => {
            onChange({ listPriceColor });
          }}
        />
      </ItemWrapper>{' '}
      <ItemWrapper size='small' title='Other Price Colour'>
        <ColorPicker
          color={otherPriceColor}
          multi
          onChange={(otherPriceColor) => {
            onChange({ otherPriceColor });
          }}
        />
      </ItemWrapper> */}
    </React.Fragment>
  );
};
export default ResponsiveText;
